module.exports = __webpack_public_path__ + "static/img/smartClass.4223c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smartClass.png
// module id = NZAg
// module chunks = 1